var map = {
	"./czosnow/deklaracja-dostepnosci_pl.mdx": [
		9080,
		9080
	],
	"./mielno/deklaracja-dostepnosci_pl.mdx": [
		7915,
		7915
	],
	"./nowa-karczma/deklaracja-dostepnosci_pl.mdx": [
		8630,
		8630
	],
	"./ostroleka/deklaracja-dostepnosci_pl.mdx": [
		6969,
		6969
	],
	"./przemysl/deklaracja-dostepnosci_pl.mdx": [
		7137,
		7137
	],
	"./slubice/deklaracja-dostepnosci_pl.mdx": [
		8982,
		8982
	],
	"./sopot/deklaracja-dostepnosci_pl.mdx": [
		5760,
		5760
	],
	"./szczecin/deklaracja-dostepnosci_pl.mdx": [
		442,
		442
	],
	"./torun/deklaracja-dostepnosci_pl.mdx": [
		7201,
		7201
	],
	"./warlubie/deklaracja-dostepnosci_pl.mdx": [
		3550,
		3550
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2682;
module.exports = webpackAsyncContext;